import React from "react";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const ParceiroParametroTopo = () => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div className="containerTitle">
        <Typography
          variant="h5"
          fontFamily={"Co Headline Regular"}
          gutterBottom
          align="left"
          marginLeft="15px"
        >
          {t("pages.justifications.titlePage")}
        </Typography>
      </div>
    </React.Fragment>
  );
};

export default ParceiroParametroTopo;
